import Addition from "../../components/ClassThree/Mathematics/Addition";
import DataHandling from "../../components/ClassThree/Mathematics/DataHandling";
import Division from "../../components/ClassThree/Mathematics/Division";
import GeometryMaps from "../../components/ClassThree/Mathematics/GeometryMaps";
import Measurements from "../../components/ClassThree/Mathematics/Measurements";
import Money from "../../components/ClassThree/Mathematics/Money";
import Multiplication from "../../components/ClassThree/Mathematics/Multiplication";
import Numbers from "../../components/ClassThree/Mathematics/Numbers";
import Patterns from "../../components/ClassThree/Mathematics/Patterns";
import Subtraction from "../../components/ClassThree/Mathematics/Subtraction";
import Time from "../../components/ClassThree/Mathematics/Time";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/class-three/mathematics/numbers", title: "Numbers", component: Numbers },
    { url: "/class-three/mathematics/addition", title: "Addition", component: Addition },
    { url: "/class-three/mathematics/subtraction", title: "Subtraction", component: Subtraction },
    { url: "/class-three/mathematics/multiplication", title: "Multiplication", component: Multiplication },
    { url: "/class-three/mathematics/division", title: "Division", component: Division },
    { url: "/class-three/mathematics/geometry-maps", title: "Geometry & Maps", component: GeometryMaps },
    { url: "/class-three/mathematics/measurement", title: "Measurement", component: Measurements },
    { url: "/class-three/mathematics/time", title: "Time", component: Time },
    { url: "/class-three/mathematics/money", title: "Money", component: Money },
    { url: "/class-three/mathematics/data-handling", title: "Data Handling", component: DataHandling },
    { url: "/class-three/mathematics/patterns", title: "Patterns", component: Patterns },
];


export default topics;